import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AdminMainPanel from '../Layouts/AdminMainPanel';
import NavBar from '../Layouts/NavBar';
import { actionCreators as settingsActionCreators } from '../../reducers/settings';
import TabbedSettingsForm from './TabbedSettingsForm';

const Settings = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(settingsActionCreators.loadSettings());
    }, []);

    return (
        <div className="settings settings-full-width">
            <AdminMainPanel>
                <NavBar className={'settings-panel'} />
                <div className="admin-main-content settings-panel">
                    <h3 className="title">Site Settings</h3>
                </div>

                <TabbedSettingsForm />
            </AdminMainPanel>
        </div>
    );
};

export default Settings;
